import React from 'react';
import { cx } from '@emotion/css';
import type { IconProps } from '../Icon';
import { Black } from '../constants/colors';
import { Sizes } from '../constants/sizes';

const SortTrianglesIcon = (props: IconProps): JSX.Element => {
  const {
    className,
    'data-testid': dataTestId,
    fill = Black.V100,
    size = Sizes.Medium,
    onClick,
    onMouseEnter,
    onMouseLeave,
  } = props;
  const classNames = cx('sds-icon', 'sds-icon-sort-triangles', className);
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill={fill}
      xmlns='http://www.w3.org/2000/svg'
      className={classNames}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      data-testid={dataTestId}
    >
      <g clipPath='url(#clip0)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M8.23081 2.61111L11.6924 7.05556C11.835 7.23868 11.6993 7.5 11.4616 7.5L4.53845 7.5C4.30075 7.5 4.16506 7.23868 4.30768 7.05556L7.76926 2.61111C7.88465 2.46296 8.11542 2.46296 8.23081 2.61111Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M7.76919 13.3889L4.30762 8.94444C4.16499 8.76132 4.30068 8.5 4.53839 8.5L11.4615 8.5C11.6993 8.5 11.8349 8.76132 11.6923 8.94444L8.23074 13.3889C8.11535 13.537 7.88458 13.537 7.76919 13.3889Z'
        />
      </g>
      <defs>
        <clipPath id='clip0'>
          <rect width={16} height={16} fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SortTrianglesIcon;
